/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiLink, EuiToolTip } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import usePermissions from '@modules/permissions-lib/hooks'

interface Props {
  onReviewChanges: () => void
  children: React.ReactNode
}

const ReviewChangesLink = ({ onReviewChanges, children }: Props) => {
  const { hasPermissions } = usePermissions([
    {
      type: 'feature-usage',
      action: 'list',
    },
  ])

  if (!hasPermissions) {
    return (
      <EuiToolTip
        content={
          <FormattedMessage
            id='feature-usage-banner.no-permission.review-changes'
            defaultMessage='You do not have permission to review changes.'
          />
        }
      >
        <EuiLink disabled={!hasPermissions} onClick={onReviewChanges}>
          {children}
        </EuiLink>
      </EuiToolTip>
    )
  }

  return <EuiLink onClick={onReviewChanges}>{children}</EuiLink>
}

export default ReviewChangesLink
